<template>
  <div class="modal fade update-user-modal" id="UpdateUserModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Editar usuário</h1>
                  <button type="button" class="btn-close update-user-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formUpdateUser" v-on:submit="updateUserMethod()">
                <div class="modal-body ps-30 pe-30">
                  <p>Preencha as informações abaixo para criar um usuário</p>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="name_user_update" class="form-label fw-medium"
                      >Nome</label
                    > 
                    <input
                      :value="getCurrentUpdateUser.name"
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="name_user_update"
                      placeholder="Digite o nome"
                      autocomplete="off"
                      required
                    />
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="cellphone_user_update" class="form-label fw-medium"
                      >Celular (opcional)</label
                    >                      
                      <input
                        :value="getCurrentUpdateUser.cell_phone"
                        id="cellphone_user_update"
                        ref="cellphone_update"
                        type="text"
                        class="form-control shadow-none rounded-0 text-black radius-7"
                        placeholder="Digite o celular"
                        @keyup="changeInformationInputs('cellphone_update')"
                        @input="applyMaskPhone"
                        maxlength="15"
                      />
                  </div>

                <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                  <label for="access" class="form-label fw-medium">Nível de acesso</label>
                  <select 
                    v-model="selectedRoleId"
                    @change="setPermissionsToSave()" 
                    ref="access_update" 
                    id="access_update" 
                    class="form-select shadow-none text-black fs-md-15" 
                    required
                  >
                    <option 
                      v-for="role in getRolesList" 
                      :value="role.id" 
                      :key="role.id"
                    >
                      {{ role.name }}
                    </option>
                  </select>

                  <div v-if="perms.length > 0" class="form-text mb-15 mb-mb-15 mb-md-20 col-12">
                    <strong>Acesso liberado: </strong>
                    <div>
                      <span>
                        {{  perms.join(", ") }}
                      </span>
                    </div>
                  </div>
                </div>

                <div 
                  v-if="(getRolesList.find(r => r.id == selectedRoleId) && getRolesList.find(r => r.id == selectedRoleId).name !== 'Administrador')" 
                  class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30"
                >
                  <label for="form-check" class="form-label fw-medium">Acesso as operações</label>
                  <div v-for="(operation, key) in getOperations" :key="key" class="form-check mb-10">
                    <input class="form-check-input shadow-none" type="checkbox" :value="operation.id" :id="`up-op-${operation.id}`" v-model="selectedOperations">
                    <label class="form-check-label fw-medium position-relative top-1" :for="`up-op-${operation.id}`">
                      {{ operation.name }}
                    </label>
                  </div>
                </div>

                <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                  <label for="password_update" class="form-label fw-medium"
                    >Sua senha para confirmar</label
                  >
                  <input
                    type="password"
                    class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                    id="password_update"
                    autocomplete="off"
                    required
                  />

                  <div class="form-text mb-15 mb-mb-15 mb-md-20 col-12">
                    Por segurança, precisamos que você confirme sua senha para realizar a alteração deste usuário.
                  </div>
                </div>

                  <div class="col-12">
                    <div id="alertResponseApiUpdateUser" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageUpdateUser">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="submit" ref="buttonUpdateUser" class="btn btn-success">Salvar</button>
                  <button type="button" class="btn btn-danger update-user-modal" data-bs-dismiss="modal">Cancelar</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../config/axios.js';
import { mapGetters } from 'vuex';

export default {
  name: "UpdateUserModal",
  data () {
    return {
      perms: [],
      selectedOperations: [],
      selectedRoleId: null,
    }
  },
  computed: {
    ...mapGetters([
      "getRolesList",
      "getCurrentUpdateUser",
      "getOperations"
    ]),
    currentRole() {
      return this.getRolesList.find(r => r.id == this.selectedRoleId) || null;
    }
  },
  watch: {
    // Quando o select muda, atualiza permissões
    selectedRoleId() {
      this.perms = this.currentRole ? this.currentRole.permissions : [];
    },
    // Se a lista de roles vier async, tenta fixar o valor assim que chegar
    getRolesList: {
      immediate: true,
      handler() { this.initSelectedRole(); }
    },
    // Se o usuário atual mudar, re-inicializa
    getCurrentUpdateUser: {
      immediate: true,
      handler() { this.initSelectedRole(); }
    }
  },
  methods: {
    initSelectedRole() {
      if (!this.getRolesList?.length || !this.getCurrentUpdateUser) return;

      const byName = this.getRolesList.find(
        r => r.name === this.getCurrentUpdateUser.permission_name
      );

      this.selectedRoleId = byName ? byName.id : null;
      this.perms = this.currentRole ? this.currentRole.permissions : [];

      console.log(this.getCurrentUpdateUser);
      this.selectedOperations = this.getCurrentUpdateUser.operations_permissions || [];
    },
    setPermissionsToSave() {
      this.perms = this.currentRole ? this.currentRole.permissions : [];
    },
    changeInformationInputs(element){
      this.$refs[element].style.borderColor = "#dedee4";
    },
    applyMaskPhone(event) {
      const input = event.target;
      let value = input.value.replace(/\D/g, '');

      if (value.length > 10) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }

      input.value = value;
    },
    updateUserMethod(){
      event.preventDefault();
      const alertResponse = this.alertResponse;

      const id_delete = this.getCurrentUpdateUser.id;
      const name_user_update = document.getElementById("name_user_update").value;
      const cellphone_user_update = document.getElementById("cellphone_user_update").value;
      const password_update = document.getElementById("password_update").value;
      const access_update = this.selectedRoleId;
      
      if(!name_user_update || !access_update || !password_update){
        this.alertResponse("Por favor preencha todos os campos", true);
        return;
      }

      const isAdmin = (this.getRolesList.find(r => r.id == this.currentAcces) && 
        this.getRolesList.find(r => r.id == this.currentAcces).name == 'Administrador');

      if(!isAdmin && this.selectedOperations.length == 0
      ){
        alertResponse("Preencha pelo menos uma operação", true);
        return;
      }

      const objUserCreate= {
        "id": id_delete,
        "name": name_user_update,
        "celular": cellphone_user_update,
        "access": access_update,
        "password": password_update,
        "permissions_operations": !isAdmin ? this.selectedOperations : null
      }

      const buttonUpdateUser = this.$refs.buttonUpdateUser;
      buttonUpdateUser.disabled = true;
      buttonUpdateUser.innerHTML = "Salvando...";
      

      api.axios.post("/api/update/user", objUserCreate).catch(function(error){
        if(error.response.data != undefined){
          buttonUpdateUser.innerHTML = "Salvar";
        }
        console.log("error", error);
        alertResponse(error.response.data, true);
      }).then(function(response){
        
        if(response != undefined && response.status == 200){
          buttonUpdateUser.innerHTML = "Informações salvas com sucesso !";
          window.location.reload();
        } else {
          buttonUpdateUser.disabled = false;
          buttonUpdateUser.innerHTML = "Salvar";
        }
      });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageUpdateUser").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageUpdateUser").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiUpdateUser");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }

      const password = document.getElementById("password_update");
      if(password){
        password.value = "";
      }
    },
  }
};
</script>